<ng-container *ngIf="!standerdProcessBool">
  <div class="fixed transform z-1" *ngIf="showProgressSpinner">
    <app-custom-spinner></app-custom-spinner>
  </div>
  <div class="bg-default px-3 pb-3">
    <div class="flex justify-content-between align-items-center title-bg title-case">
      <div class="conten standard-small">
        <div class="btn"><a>Standard Process</a></div>
      </div>
      <div class="flex justify-content-end standard-spec" id="facility_specs_search">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="searchField" (input)="applyFilterGlobal($event, 'contains')"
            placeholder="Search Facility..." />
            <i class="pi pi-times case-keywordsearch" *ngIf="crossSearchBool" (click)="clearSearchField()"></i>
        </span>
      </div>

    </div>
    <app-common-facility-grid [commonFacilityData]="standardProcessGrid"
    [totalRecords]="totalRecords"
    (lazyLoadEvent)="lazyLoadSchedulesForSpec($event)"
    (standerprocessIconPreParam)="implementationBool = true;implementationName = 'Pre Implementation';showStanderdProcess($event)"
    (standerprocessIconPostParam)="implementationBool = true;implementationName = 'Post Implementation';showStanderdProcess($event)">
  </app-common-facility-grid>

    <div class="md:col-12">
      <span class="tableRefreshTime">
        Grid Last Refreshed at {{PiTeamService._currentDate}} - {{PiTeamService._currentTime}}
      </span>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="standerdProcessBool">
  <div class="backbtn-standard  cursor-pointer" (click)="BackToCases()" pTooltip="Back" tooltipPosition="right">
    <i class="pi pi-arrow-left"></i>
  </div>
  <div class="bg-default px-3 pb-3">
    <div class="flex justify-content-between align-items-center title-bg title-case">
      <div class="conten">
        <div class="btn"><a>Standard Process</a></div>
      </div>
    </div>
    <h2 class="pre-post">PRE IMPLEMENTATION</h2>
    <div class="grid ems-codes m-auto flex justify-content-center align-items-center"
      style="border-bottom: 1px solid #8D69B1 !important;">

      <div class="col-12 md:col-6 lg:col-3">
        <div class="ems-card" (click)="showEMS('Pre Implentation')">
          <div class="icon">
            <img class="w-4rem" src="../../../../../../../assets/images/EMS.svg">
          </div>
          <p class="title">EMS</p>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="ems-card" (click)="showTriage('Pre Implentation')">
          <div class="icon">
            <img class="w-4rem" src="../../../../../../../assets/images/walkinpatient.svg">
          </div>
          <p class="title">Triage/Walk-In</p>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="ems-card" (click)="showInpatient('Pre Implentation')">
          <div class="icon">
            <img class="w-4rem" src="../../../../../../../assets/images/Inpatient.svg">
          </div>
          <p class="title">Inpatient</p>
        </div>
      </div>
    </div>

    <!-- Post Implementation -->
    <h2 class="pre-post">POST IMPLEMENTATION</h2>
    <div class="grid ems-codes m-auto flex justify-content-center align-items-center">

      <div class="col-12 md:col-6 lg:col-3">
        <div class="ems-card" (click)="showEMS('Post Implentation')">
          <div class="icon">
            <img class="w-4rem" src="../../../../../../../assets/images/EMS.svg">
          </div>
          <p class="title">EMS</p>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="ems-card" (click)="showTriage('Post Implentation')">
          <div class="icon">
            <img class="w-4rem" src="../../../../../../../assets/images/walkinpatient.svg">
          </div>
          <p class="title">Triage/Walk-In</p>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="ems-card" (click)="showInpatient('Post Implentation')">
          <div class="icon">
            <img class="w-4rem" src="../../../../../../../assets/images/Inpatient.svg">
          </div>
          <p class="title">Inpatient</p>
        </div>
      </div>


    </div>

  </div>
</ng-container>

<!-- dialog pre post implementation -->

<p-dialog header="{{implementationName}}" [draggable]="false" [modal]="true" [(visible)]="implementationBool"
  [breakpoints]="{'960px': '75vw'}" [style]="{width: '40vw'}">
  <div class="fixed transform z-1" *ngIf="showProgressSpinner">
    <app-custom-spinner></app-custom-spinner>
  </div>
  <div class="grid mt-5">
    <div class="col-12 md:col-6 lg:col-4">
      <div class="ems-card"
        (click)="implementationName == 'Pre Implementation'?showEMS('Pre Implentation'):showEMS('Post Implentation')">
        <div class="icon">
          <img class="w-4rem" src="../../../../../../../assets/images/EMS.svg">
        </div>
        <p class="title">EMS</p>
      </div>
      <div class="download-view">
        <a class="img-outer">
          <img pTooltip="View Uploaded EMS" tooltipPosition="bottom"
            src="../../../../../../../assets/images/view-document.svg" (click)="ViewDownloadedDocument('ems',1)">
        </a>
        <p><b>View Uploaded<br> Documents</b></p>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-4">
      <div class="ems-card"
        (click)="implementationName == 'Pre Implementation'?showTriage('Pre Implentation'):showTriage('Post Implentation')">
        <div class="icon">
          <img class="w-4rem" src="../../../../../../../assets/images/walkinpatient.svg">
        </div>
        <p class="title">Triage/Walk-In</p>
      </div>
      <div class="download-view">
        <a class="img-outer">
          <img pTooltip="View Uploaded Triage/Walk-In" tooltipPosition="bottom"
            (click)="ViewDownloadedDocument('triage',3)" src="../../../../../../../assets/images/view-document.svg">
        </a>
        <p><b>View Uploaded<br> Documents</b></p>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-4">
      <div class="ems-card"
        (click)="implementationName == 'Pre Implementation'?showInpatient('Pre Implentation'):showInpatient('Post Implentation')">
        <div class="icon">
          <img class="w-4rem" src="../../../../../../../assets/images/Inpatient.svg">
        </div>
        <p class="title">Inpatient</p>
      </div>
      <div class="download-view">
        <a class="img-outer">
          <img pTooltip="View Uploaded Inpatient" tooltipPosition="bottom"
            (click)="ViewDownloadedDocument('inpatient',2)" src="../../../../../../../assets/images/view-document.svg">
        </a>
        <p><b>View Uploaded<br> Documents</b></p>
      </div>
    </div>
  </div>
  <div class="formgrid flex m-2">
    <div class="col-12 md:col-12 text-right mt-5" *ngIf="!isAccessRead">
      <button pButton type="button" (click)="CancelImplementation()" class=" btn-UnCancelCase">
        <i class="pi pi-times"></i>&nbsp;<b>Cancel</b> </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="{{fileUploadName}}" [draggable]="false" [modal]="true" [(visible)]="fileUploadBool"
  [breakpoints]="{'960px': '75vw'}" [baseZIndex]="5000">
  <h3><b>{{FacilityName}}</b></h3>
  <div class="grid">
    <p-table #dt [value]="getFileUploadStandardProcessArray" [rows]="rows"
      styleClass="p-datatable-striped p-datatable-gridlines" [lazy]="true" [scrollable]="true" scrollHeight="400px"
      [rowHover]="true" dataKey="Id" [columns]="cols">
      <ng-template pTemplate="header">
        <tr>
          <th style="min-width:270px">Name</th>
          <th style="min-width:200px">Document Type</th>
          <th style="min-width:100px">Date</th>
          <th style="min-width:100px">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-getFileUploadStandardProcessArray let-rowIndex="rowIndex">
        <tr>
          <td class="surface-overlay white-space-nowrap overflow-hidden text-overflow-ellipsis" style="min-width:270px">
            {{getFileUploadStandardProcessArray.qfs_fileName}}
          </td>
          <td style="min-width:200px">
            {{getFileUploadStandardProcessArray.qfs_uploadedDocument}}
          </td>
          <td style="min-width:100px">
            {{getFileUploadStandardProcessArray.qfs_FileUploadingDate | date: 'MM/dd/yyyy'}}
          </td>
          <td class="flex  align-items-center" style="min-width:100px">

            <p-image class="mr-2 cursor-pointer" src="../../../../../../../assets/images/dowbload.svg" pTooltip="Download File"
              tooltipPosition="left"
              (click)="showDownloadDocument(rowIndex,'download', getFileUploadStandardProcessArray.qfs_fileName)"
              alt="Image" width="25px"></p-image>
              <div [style]="getFileUploadStandardProcessArray.wordFileDnone">
            <p-image class="mr-2 cursor-pointer" src="../../../../../../../assets/images/view.svg" pTooltip="View File"
              tooltipPosition="bottom"
              (click)="showDownloadDocument(rowIndex,'show', getFileUploadStandardProcessArray.qfs_fileName)"
              alt="Image" width="25px" ></p-image>
            </div>
            <p-image *ngIf="isAccessReadWrite && !roleForFacility" class="mr-2 cursor-pointer" src="../../../../../../../assets/images/Delete.svg" pTooltip="Delete File"
              tooltipPosition="bottom" (click)="DeleteDownloadDocument( getFileUploadStandardProcessArray.qfs_Id)"
              alt="Image" width="25px"></p-image>

          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <h5 *ngIf="totalRecords==0" class="text-center create-roles">
            <b> No records found</b>
          </h5>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="formgrid flex m-2">
    <div class="col-12 md:col-12 text-right mt-5" *ngIf="!isAccessRead">
      <button pButton type="button" (click)="CancelDownloadedDocument()" class=" btn-UnCancelCase">
        <i class="pi pi-times"></i>&nbsp;<b>Cancel</b> </button>
    </div>
  </div>
</p-dialog>

<!-- Cancle Toast -->
<p-toast [style]="{width: '25vw',opacity:'1'}" position="center" key="c" (onClose)="OnReject()">
  <p-toast key="DeleteContact" position="top-right"></p-toast>
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <p-button label="YES" class="ml-2 p-button-primary btn-padding-custom" (click)="OnConfirm()" type="button">
          </p-button>
        </div>
        <div class="col-6">
          <p-button label="No" class="ml-2 p-button-secondary btn-padding-custom" (click)="OnReject()" type="button">
          </p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
